import { baseConfiguration } from '../components/base/baseConfiguration.js';
import { chartingConfiguration } from '../components/charting/chartingConfiguration.js';
import { factConfiguration } from '../components/fact/factConfiguration.js';
import { fileConfiguration } from '../components/file/fileConfiguration.js';
import { managementConfiguration } from '../components/management/managementConfiguration.js';
import { messageConfiguration } from '../components/message/messageConfiguration.js';
import { overviewConfiguration } from '../components/overview/overviewConfiguration.js';
import { portalConfiguration } from '../components/portal/portalConfiguration.js';
import { riskConfiguration } from '../components/risk/riskConfiguration.js';
import { svgConfiguration } from '../components/svg/svgConfiguration.js';
import { IComponentConfiguration } from '../models/IComponentConfiguration.js';
/* [Category: import] */

export const configuration: IComponentConfiguration = {
	base: baseConfiguration,
	charting: chartingConfiguration,
	management: managementConfiguration,
	overview: overviewConfiguration,
	file: fileConfiguration,
	risk: riskConfiguration,
	fact: factConfiguration,
	message: messageConfiguration,
	portal: portalConfiguration,
	svg: svgConfiguration,
	/* [Category: interface] */
	global: {
		formats: {
			date: {
				type: 'date',
				options: {
					day: '2-digit',
					month: 'short',
					year: '2-digit',
				},
			},
			percent: {
				type: 'percent',
				options: {
					maximumFractionDigits: 2,
					minimumFractionDigits: 2,
				},
				transforms: [
					{
						operator: 'divide',
						value: 100,
					},
				],
			},
		},
	},
};
